module.exports = __webpack_public_path__ + "img/icon-arrow-down.d46385d6.svg";